import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const BioToiletIcon = (props)=>/*#__PURE__*/ jsxs("svg", _objectSpreadProps(_objectSpread({}, props), {
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M9.12957 2.10258C9.01822 1.96607 8.8598 1.89076 8.68417 1.89076H8.26058C7.92194 1.89076 7.61084 2.17907 7.5523 2.5474L6.64649 7.35455L5.50208 2.5321C5.4309 2.17201 5.11407 1.89076 4.78117 1.89076H4.5424C4.2049 1.89076 3.89381 2.16377 3.82034 2.52504L2.65969 7.36749L1.72305 2.54622C1.66221 2.17201 1.35801 1.89076 1.01363 1.89076H0.590037C0.413254 1.89076 0.254838 1.96607 0.143488 2.10258C0.024102 2.24967 -0.0241116 2.4509 0.0114746 2.65448L1.65868 11.0096C1.72297 11.3697 2.03635 11.6521 2.3727 11.6521H2.68953C3.02129 11.6521 3.33927 11.3744 3.41503 11.019L4.65604 6.00003L5.8831 11.0166C5.95657 11.3732 6.27226 11.6521 6.60401 11.6521H6.91855C7.25375 11.6521 7.56713 11.3697 7.63027 11.0096L9.26158 2.65448C9.29717 2.45208 9.24895 2.25085 9.12957 2.10258Z",
                fill: props.fill
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M15.8966 5.0052C15.8932 4.96284 15.8863 4.884 15.8737 4.78279C15.853 4.60393 15.8278 4.438 15.8002 4.28738C15.7738 4.14499 15.744 4.01907 15.7118 3.91199C15.5798 3.46835 15.3915 3.08707 15.1516 2.77994C14.9071 2.46692 14.6064 2.22568 14.2574 2.06446C13.9141 1.9056 13.5181 1.8244 13.0784 1.8244C12.5952 1.8244 12.1532 1.93384 11.7652 2.15037C11.3783 2.36571 11.0466 2.67638 10.7803 3.07178C10.5197 3.45893 10.3188 3.92964 10.1833 4.47213C9.86948 5.72892 9.96069 7.09885 10.1834 8.47954L10.2259 8.74196L10.4382 8.58898C10.7734 8.34774 11.0202 8.19358 11.6264 8.0712L11.7733 8.04178L11.7572 7.8888C11.6468 6.85791 11.5274 6.07188 11.717 5.05227C11.7801 4.71454 11.8765 4.42506 12.0028 4.19441C12.1234 3.97436 12.2691 3.80961 12.4482 3.69075C12.6227 3.57543 12.8293 3.51895 13.0807 3.51895C13.292 3.51895 13.4722 3.55425 13.6157 3.6225C13.7511 3.68722 13.8602 3.7849 13.952 3.9214C14.0507 4.0685 14.1277 4.26149 14.1828 4.49802C14.1908 4.53214 14.1977 4.56745 14.2057 4.6051C14.2229 4.69807 14.239 4.8028 14.2516 4.91577C14.2585 4.97931 14.2631 5.02756 14.2666 5.06051C14.3079 5.44178 14.588 5.72892 14.9174 5.72892H15.3261C15.4834 5.72892 15.6303 5.66066 15.7382 5.53828C15.8611 5.39824 15.9196 5.2029 15.8989 5.0052H15.8966Z",
                fill: props.fill
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M6.98499 12.5099C7.51135 13.5 10.2327 15.3517 13.5114 14.5C15.8433 13.8942 16.6449 11.5003 15.4361 10.38C15.4361 10.38 14.0114 13 10.5114 12.5C13.5114 11.5 14.1963 9.55861 14.1963 9.55861C13.0381 8.84902 11.7597 8.3489 10.0114 10.38C8.46967 12.1699 7.79543 12.2569 6.98613 12.5099H6.98499Z",
                fill: props.fill
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M15.8473 7.94056C15.7256 7.81583 15.4605 7.81818 15.2917 7.81818H15.0162C14.6913 7.81818 14.5697 8.08766 14.5065 8.49717C14.4354 8.95729 14.3607 9.2656 14.1954 9.55979C14.2528 9.6151 14.8498 9.91989 15.4352 10.3812C15.5925 10.1235 15.7291 9.79515 15.8106 9.52685C15.8381 9.43388 15.8657 9.32444 15.8898 9.20323C15.9173 9.06202 15.9426 8.90551 15.9633 8.73841C15.9759 8.64309 15.9828 8.56778 15.9862 8.53248C16.0103 8.22887 15.9988 8.09825 15.8473 7.94174V7.94056Z",
                fill: props.fill
            })
        ]
    }));
BioToiletIcon.defaultProps = {
    width: 16,
    height: 16,
    fill: 'currentColor'
};

export { BioToiletIcon as default };
//# sourceMappingURL=BioToilet.mjs.map
